import React from 'react';
import { NavLink } from 'react-router-dom';
import Fb from '../assets/images/fb-icon.svg';
// import Gplus from '../assets/images/gplus-icon.svg';
import Twitter from '../assets/images/twitter-icon.svg';
import { lang } from '../lang';

const Footer = () => (
  <footer className="main-footer">
    <div className="main-container -footer">
      <span className="copyright">
        Copyright &copy; {new Date().getFullYear()} Search Administrator
      </span>
      <ul className="navbar-list -footer">
        <li className="item">
          <NavLink className="navbar-link" to="/eula">
            {lang.eula}
          </NavLink>
        </li>
        <li className="item">
          <NavLink className="navbar-link" to="/privacy-policy">
            {lang.pp}
          </NavLink>
        </li>
        <li className="item">
          <NavLink className="navbar-link" to="/support">
            {lang.support}
          </NavLink>
        </li>
        <li className="item">
          <NavLink className="navbar-link" to="/uninstall">
            {lang.uninstall}
          </NavLink>
        </li>
      </ul>

      <ul className="social-list">
        <li className="item">
          <a
            className="navbar-link"
            href="https://www.facebook.com/Search-Administrator-475853249587651"
            target="_blank"
          >
            <img className="social-link" src={Fb} alt="fb" />
          </a>
        </li>
        {/* <li className="item">
          <a className="navbar-link" to="https://twitter.com/SearchAdmin" target="_blank">
            <img className="social-link" src={Gplus} alt="gplus" />
          </a>
        </li> */}
        <li className="item">
          <a className="navbar-link" href="https://twitter.com/SearchAdmin" target="_blank">
            <img className="social-link" src={Twitter} alt="twitter" />
          </a>
        </li>
      </ul>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js